import type { LookupParams } from "epsm-api-types";
import type { News } from "epsm-api-types/models";
import { useEffect } from "react";
import { LOCAL_FIELDS, NEWS_COLUMNS, TICKER_FILTER } from "../../../types";
import { isTickerFilter } from "../../helpers/isTickerFilter";

export const LOOKUP_FIELD = {
	NEWS_SP500: "securityRaw.sp500_member_flag" as keyof News,
};

export function useNewsFilterByTickerFilter(
	ticker: string,
	setLookup: (v?: LookupParams) => void,
) {
	useEffect(() => {
		switch (isTickerFilter(ticker) && ticker) {
			case TICKER_FILTER.TOP:
				setLookup({
					from: LOCAL_FIELDS.SECURITY_RAW,
					localField: LOCAL_FIELDS.COMPANY_TICKER,
					foreignField: NEWS_COLUMNS.TICKER,
					filter: [
						{ name: LOOKUP_FIELD.NEWS_SP500, condition: "eq", value: true },
					],
				});
				break;
			case TICKER_FILTER.OTHER:
				setLookup({
					from: LOCAL_FIELDS.SECURITY_RAW,
					localField: LOCAL_FIELDS.COMPANY_TICKER,
					foreignField: NEWS_COLUMNS.TICKER,
					filter: [
						{ name: LOOKUP_FIELD.NEWS_SP500, condition: "eq", value: false },
					],
				});
				break;

			default:
				setLookup();
		}
	}, [setLookup, ticker]);
}
